// extracted by mini-css-extract-plugin
export default {"toolbar":"styles_toolbar__c5Uvw"};